// item script extends base script
import "./base";
// import items from "./app/store/modules/singleItem/BaseItemModule";

// ceresStore.registerModule("items", items);
// =========================
// Basket
// =========================
Vue.component("add-to-basket", () => import("./app/components/basket/AddToBasket.vue"));

// =========================
// SingleItem
// =========================
import SingleItem from "./app/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);
import ItemImageCarousel from "./app/components/item/ItemImageCarousel.vue";
Vue.component("item-image-carousel", ItemImageCarousel);
import VariationProperties from "./app/components/item/VariationProperties.vue";
Vue.component("variation-properties-ks", VariationProperties);
import VariationDescription from "./app/components/item/VariationDescription.vue";
Vue.component("variation-description", VariationDescription);

Vue.component("order-property-list", () => import("./app/components/item/OrderPropertyList.vue"));
Vue.component("shipping-vat-info", () => import("./app/components/item/ShippingVatInfo.vue"));
Vue.component("order-properties", () => import("./app/components/item/OrderProperties.vue"));

Vue.component("graduated-prices", () => import("./app/components/item/GraduatedPrices.vue"));
Vue.component("ks-timer", () => import("./app/components/item/TimerKs.vue")),
Vue.component("lazy-youtube", () => import("./app/components/item/LazyYoutube.vue")),
// Vue.component("item-price", () => import("./app/components/item/ItemPrice.vue"));
Vue.component("order-property-list", () => import("./app/components/item/OrderPropertyList.vue"));
Vue.component("variation-select", () => import("./app/components/item/VariationSelect.vue"));
// Vue.component("item-availability", () => import("./app/components/item/ItemAvailability.vue"));

